const getChargebeeSiteId = () => (process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
  ? 'getinthelooplocal-test'
  : 'getinthelooplocal');

export default getChargebeeSiteId;
